import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Menu } from 'antd';
import ReactDOM from 'react-dom';
import { Link } from 'react-router-dom';
import TabsService from 'services/TabsService';
import ModalsService from 'services/ModalsService';
import ProcessService from 'services/ProcessService';
import RollupError from 'components/core/RollupError';
import _ from 'underscore';


class TabbedNavigation extends React.Component {

    static propTypes = {
        openTabs: PropTypes.array,
        tabModes: PropTypes.object,
        activeTab: PropTypes.string,
        lastTabSubpaths: PropTypes.object,
        dirtyTabs: PropTypes.array,
        dispatch: PropTypes.func,
        processErrorsById: PropTypes.object,
        processRevisionErrorsById: PropTypes.object,
        showTabs: PropTypes.bool
    };

    static defaultProps = {
        showTabs: true
    };

    constructor(props) {
        super(props);
        this.state = {
            leftPosition: 0
        };
        this.handleWindowResize = this.handleWindowResize.bind(this);
        this.handleScrollLeft = this.handleScrollLeft.bind(this);
        this.handleScrollRight = this.handleScrollRight.bind(this);
        this.paddingForArrow = 35;
    }

    getTabsWidth() {
        let tabsWidth = 0;
        const refs = this.refs;
        Object.keys(this.refs).forEach((key) => {
            if (key.startsWith('navItem_')) {
                tabsWidth += ReactDOM.findDOMNode(refs[key]).clientWidth;
            }
        });
        return tabsWidth;
    }

    getClassName(tabId) {
        return this.props.activeTab === tabId ? 'active' : '';
    }

    handleWindowResize() {
        this.showHideTabScrollerButtons();
    }

    handleScrollLeft() {
        const containerWidth = this.refs.wrapper.clientWidth;
        const currentLeftPosition = this.state.leftPosition;
        let newLeftPosition = 0;
        // for case where window gets resized its possible to move too much to left
        // so never set leftPosition to be greater than zero
        if (currentLeftPosition + containerWidth + this.paddingForArrow < 0) {
            newLeftPosition = currentLeftPosition + containerWidth - this.paddingForArrow - this.paddingForArrow;
        }
        this.setState({
            leftPosition: newLeftPosition
        });
    }

    handleScrollRight() {
        const containerWidth = this.refs.wrapper.clientWidth;
        const allTabsWidth = this.getTabsWidth();
        const tabsOffScreenOnRightWidth = allTabsWidth - containerWidth + this.state.leftPosition;
        const currentLeftPosition = this.state.leftPosition;
        const refs = this.refs;
        //scroll a whole page worth of tab's to the right but align to the left of the first invisible tab
        if (tabsOffScreenOnRightWidth > containerWidth) {
            //loop thru each tab and for the tab that comes after the last tab within view, get its
            // left position and use that for the tabs' left position:
            let foundTabWithinView = false;
            let firstInvisibleTab = null;
            this.props.openTabs.forEach((tab) => {
                const tabNode = ReactDOM.findDOMNode(refs[`navItem_${tab}`]);
                if (!foundTabWithinView) {
                    if (this.isElementInViewport(tabNode)) {
                        foundTabWithinView = true;
                    }
                } else if (firstInvisibleTab === null) {
                    if (!this.isElementInViewport(tabNode)) {
                        firstInvisibleTab = tabNode;
                    }
                }
            });
            this.setState({
                leftPosition: currentLeftPosition - firstInvisibleTab.getBoundingClientRect().left + this.paddingForArrow
            });
        } else {
            this.setState({
                leftPosition: currentLeftPosition - tabsOffScreenOnRightWidth - this.paddingForArrow
            });
        }
    }

    showHideTabScrollerButtons() {
        if (this.showRightArrow()) {
            this.refs['scroller-right'].classList.remove('hidden');
            this.refs['scroller-right'].classList.add('shown');
        } else {
            this.refs['scroller-right'].classList.remove('shown');
            this.refs['scroller-right'].classList.add('hidden');
        }

        if (this.showLeftArrow()) {
            this.refs['scroller-left'].classList.remove('hidden');
            this.refs['scroller-left'].classList.add('shown');
        } else {
            this.refs['scroller-left'].classList.remove('shown');
            this.refs['scroller-left'].classList.add('hidden');
        }

    }

    showRightArrow() {
        //remove "Home" because Home is always rendered first but can be the last item in the array
        const openTabs = this.props.openTabs;
        const pos = openTabs.indexOf('Home');
        if (pos > -1) {
            openTabs.splice(pos, 1);
        }
        const lastTabName = openTabs[openTabs.length - 1];
        const lastTabNode = ReactDOM.findDOMNode(this.refs[`navItem_${lastTabName}`]);
        return !this.isElementInViewport(lastTabNode);
    }

    isElementInViewport(el) {
        if (el) {
            const rect = el.getBoundingClientRect();

            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                rect.right <= (window.innerWidth || document.documentElement.clientWidth)
            );
        } else {
            //if no tabs besides Home exists you ain't gunna need the scroll arrow
            return true;
        }
    }

    showLeftArrow() {
        return this.state.leftPosition !== 0;
    }

    renderRollupError = (tabId) => {
        const tabObj = TabsService.getObjFromTabText(tabId);
        const tabMode = this.props.tabModes[tabId];
        const processId = tabObj.processId;
        const revisionNum = tabObj.revisionNum;

        if (this.props.processErrorsById || this.props.processRevisionErrorsById) {
            let processErrors = null;
            if (revisionNum && this.props.processRevisionErrorsById[processId]) {
                processErrors = this.props.processRevisionErrorsById[processId][revisionNum];
            } else {
                processErrors = this.props.processErrorsById[processId];
            }

            const rollupPath = tabMode === 'wizard' ? 'all-wizard' : 'all';

            if (processErrors) {
                return (
                    <RollupError
                        fieldPath={[rollupPath]}
                        processErrors={processErrors}
                        processId={processId}
                        preventOnClick={this.props.activeTab !== tabId}
                    />
                );
            }
        }

        return null;
    };

    render() {
        const tabIds = this.props.openTabs;
        const processTabs = tabIds.map((tabId) => {
            if (tabId !== 'Home') {
                const className = this.getClassName(tabId);
                const closeHandler = (e) => {
                    e.preventDefault();

                    // Confirm close if working copy has unsaved changes
                    if (_.indexOf(this.props.dirtyTabs, tabId) > -1) {
                        ModalsService.openModal({
                            id: 'close_tab',
                            modalType: ModalsService.TYPE_CONFIRM,
                            modalTitle: 'Confirm Close',
                            modalMessage: 'This tab has unsaved changes.  Close anyway?',
                            autoFocus: true,
                            onOk: () => {
                                TabsService.closeTab(tabId);
                            }
                        });
                    } else {
                        // dispatch event to close tab
                        TabsService.closeTab(tabId);
                    }
                };
                const closeButton = (
                    <button
                        type="button"
                        className="close"
                        data-dismiss="alert"
                        onClick={closeHandler}
                        title="Close Tab"
                    >
                        <span aria-hidden="true">×</span>
                        <span className="sr-only">Close</span>
                    </button>
                );

                let dirtyDecorator = '';

                // if (this.props.dirtyTabs.find(tabId)) {
                if (_.indexOf(this.props.dirtyTabs, tabId) > -1) {
                    dirtyDecorator = (
                        <span>*</span>
                    );
                }

                const lastTabSubPath = this.props.lastTabSubpaths[tabId];

                return (
                    <Menu.Item key={tabId} className={className}>
                        <Link to={lastTabSubPath}>
                            {dirtyDecorator}
                            {this.renderRollupError(tabId)}
                            {tabId}
                            {closeButton}
                        </Link>
                    </Menu.Item>
                );
            }
            return '';

        });

        const homeClass = (this.props.activeTab === 'Home') ? 'active' : '';

        return (
            <div className={'secondary-nav'}>
                {/*<WindowResizeListener onResize={this.handleWindowResize} />*/}
                <div className="scroller scroller-left hidden" ref="scroller-left" onClick={this.handleScrollLeft}><i className="fa fa-chevron-left" aria-hidden="true" /></div>
                <div className="scroller scroller-right hidden" ref="scroller-right" onClick={this.handleScrollRight}><i className="fa fa-chevron-right" aria-hidden="true" /></div>
                {this.props.showTabs &&
                    <div className="wrapper" ref="wrapper">
                        <Menu
                            className={'tabbed-nav'}
                            mode="horizontal"
                            theme="dark"
                            defaultSelectedKeys={['home']}
                            selectedKeys={[this.props.activeTab]}
                        >
                            <Menu.Item key="/processes" className={homeClass}>
                                <Link to="/processes">Home</Link>
                            </Menu.Item>
                            {processTabs}
                        </Menu>
                    </div>
                }
            </div>
        );
    }
}

// Automatically pull state information from the store and
// pass it to this component as props
const mapStateToProps = (storeState) => {
    const myState = TabsService.getMyState(storeState);
    const processState = ProcessService.getMyState(storeState);

    const dirtyTabs = myState.openTabs.map((tabId) => {
        const processUIState = processState.processUIStateById[tabId];
        if (processUIState && processUIState.dirty && processUIState.dirty === true) {
            return tabId;
        }
        return '';
    });

    const tabModes = {};
    myState.openTabs.forEach(tabId => {
        const processUIState = processState.processUIStateById[tabId];
        if (processUIState && processUIState.mode) {
            tabModes[tabId] = processUIState.mode;
        }
    });

    return {
        openTabs: myState.openTabs,
        tabModes,
        activeTab: myState.activeTab,
        lastTabSubpaths: myState.lastTabSubpaths,
        processErrorsById: processState.processErrorsById,
        processRevisionErrorsById: processState.processRevisionErrorsById,
        dirtyTabs
    };
};

// Export the class connected to the store
export default connect(mapStateToProps)(TabbedNavigation);



// WEBPACK FOOTER //
// ./src/components/core/TabbedNavigation.js